import { memdbRequest } from "./core.js";
export var OrgType;
(function (OrgType) {
    OrgType[OrgType["Federation"] = 1] = "Federation";
    OrgType[OrgType["District"] = 2] = "District";
    OrgType[OrgType["Club"] = 3] = "Club";
    OrgType[OrgType["Team"] = 4] = "Team";
})(OrgType || (OrgType = {}));
export var RoleType;
(function (RoleType) {
    RoleType[RoleType["President"] = 100] = "President";
    RoleType[RoleType["Secretary"] = 101] = "Secretary";
    RoleType[RoleType["BoardMember"] = 102] = "BoardMember";
    RoleType[RoleType["Cashier"] = 103] = "Cashier";
    RoleType[RoleType["YouthOrganizer"] = 104] = "YouthOrganizer";
    RoleType[RoleType["MemberlistKeeper"] = 105] = "MemberlistKeeper";
    RoleType[RoleType["RatinglistKeeper"] = 106] = "RatinglistKeeper";
    RoleType[RoleType["ContactPerson"] = 107] = "ContactPerson";
    RoleType[RoleType["Accountant"] = 108] = "Accountant";
    RoleType[RoleType["ElectionCommittee"] = 109] = "ElectionCommittee";
    RoleType[RoleType["Admin"] = 150] = "Admin";
    RoleType[RoleType["SuperAuditor"] = 160] = "SuperAuditor";
    RoleType[RoleType["TeamLeader1"] = 201] = "TeamLeader1";
})(RoleType || (RoleType = {}));
export const replaceRole = (role, checkEmailAndPhone, checkAddress) => memdbRequest.post(`/member/${role.memberid}/role`, {
    body: {
        role,
        checkEmailAndPhone,
        checkAddress,
    },
});
//# sourceMappingURL=role.js.map